<section *transloco="let t" class="flex h-full w-full flex-col items-center justify-center p-8 text-center">
  <h1 class="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-red-600">403</h1>
  <p class="mb-4 text-3xl tracking-tight font-bold text-zinc-900 md:text-4xl">
    {{t('errors.forbidden.title')}}
  </p>
  <p class="mb-4 text-lg font-light text-zinc-600">
    {{t('errors.forbidden.description')}}
  </p>
  <button type="button" (click)="goBack()"
    class="cursor-pointer inline-flex text-white bg-primary hover:bg-primary-600 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4"
  >
    {{t('actions.back')}}
  </button>
</section>
